const working_items = [
    {
      title: "SEPT 2008 - The beginning",
      cardTitle: "Hanoi University of science and technology",
      media: {
        name: "HUST",
        source: {
          url: "https://dean1665.vn/uploads/school/bach-khoa.jpg",
        },
        type: "IMAGE",
      },
      cardSubtitle: `The beginning of my coding and many things interesting (Friends, Love, Asia-Pacific Robot Contest ...)`,
      cardDetailedText: ``,
    },
    {
      title: "Coding low-level (coding stack)",
      cardTitle: "FPT Software - FPT",
      media: {
        name: "FPT Software",
        source: {
          url: "https://i.imgur.com/jHi6UZq.png",
        },
        type: "IMAGE",
      },
      cardSubtitle: `I started my career with embedded domain (mainly in C) with more than four years of experience coding at low-level (firmware, real-time OS, Linux BSP ...)`,
      cardDetailedText: ``,
    },
    {
      title: "Coding at the middle",
      cardTitle: "Viettel Group and Startup VP9.VN",
      media: {
        name: "Viettel Group and Startup VP9.VN",
        source: {
          url: "https://i.imgur.com/s2lOU7L.png",
        },
        type: "IMAGE",
      },
      cardSubtitle: `I then shift my domain to higher layers such as system programming (Cpp, Erlang/Elixir) or desktop apps (QT)`,
      cardDetailedText: ``,
    },
    {
      title: "Coding at the top",
      cardTitle: "Vinhomes - VinGroup",
      media: {
        name: "Vinhomes - VinGroup",
        source: {
          // url: "https://constrofacilitator.com/wp-content/uploads/2021/05/smart-city.jpg",
          url: "https://www.researchgate.net/profile/Alberto-Traballesi/publication/333377159/figure/fig1/AS:762456938917890@1558795308775/Smart-City-Components-Source-WEB.jpg",
        },
        type: "IMAGE",
      },
      cardSubtitle: `And now all about Cloud and Web technologies (REST API design, Microservices, Cloud-Native, Docker, and K8S)`,
      cardDetailedText: ``,
    },
    {
      title: "Leadership in between",
      cardTitle: "Leadership",
      media: {
        name: "Leadership",
        source: {
          // url: "https://i.imgur.com/RMhTNw4.png",
          url: "https://raw.githubusercontent.com/memto/working-chrono/working-chrono/public/leadership-full.png",
        },
        type: "IMAGE",
      },
      cardSubtitle: `Proficient in programming and software development. But my true passion is not about tech only but also about people, I do like to build (not only to manage) a team with strong tech skills, high motivation, open/agile working mindset, and close relationships.`,
      cardDetailedText: ``,
    },
  ];
  
  export default working_items;
  